import React from 'react';
import { BarChart3 } from 'lucide-react';

const BetListLiveTab = () => {
  return (
    <div className="p-8 text-center">
      <BarChart3 className="w-16 h-16 text-[#2B6EF5] mx-auto mb-4" />
      <h3 className="text-xl font-semibold text-[#F9F9F9] mb-2">BetListLive</h3>
      <p className="text-[#878AA2]">Live betting lists and real-time updates.</p>
    </div>
  );
};

export default BetListLiveTab; 